import {Component, OnInit, ViewChild} from '@angular/core';
import {Model} from '../../../Models/Model';
import {Helper} from '../../../../helpers/helper.service';
import {ActivatedRoute} from '@angular/router';
import {ModelService} from '../../../Services/model.service';
import {Product} from '../../../Models/Product';
import {ProductService} from '../../../Services/product.service';

@Component({
  selector: 'app-view-model',
  templateUrl: './view-model.component.html',
  styleUrls: ['./view-model.component.scss']
})
export class ViewModelComponent implements OnInit {
  public model: Model = new Model();
  public modelId: number;
  public productId;
  public productName;
  public hasStyle = false;
  @ViewChild('deleteProduct', {static: false}) deleteProduct = null;

  constructor(private route: ActivatedRoute, private modelService: ModelService, private productService: ProductService) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.modelId = params['id'];
        this.getModelItem();
      }
    });
  }

  getModelItem(callback = null) {
    this.modelService.getModelItem(this.modelId).subscribe((resp) => {
      this.model = resp;
      if (Array.isArray(this.model.styles) && this.model.styles.length > 0) {
        this.hasStyle = true;
      }
      if (typeof callback === 'function') {
        callback();
      }
    });
  }

  getModel() {
    return Model;
  }

  getProduct() {
    return Product;
  }

  showDeleteProduct(id: number, name: string) {
    this.productId = id;
    this.productName = name;
    this.deleteProduct.show();
  }

  softDelete() {
    this.productService.softDeleteProduct(this.productId).subscribe((res) => {
      this.getModelItem(() => {
        this.deleteProduct.hide();
      });
    });
  }

  positionChange(productId, positionNumber) {
    const position = {position: positionNumber};
    this.modelService.setParentPosition(productId, position).subscribe(
      (res) => {
        this.getModelItem();
      }
    );
  }
}
